import { render, staticRenderFns } from "./RentalSpace.vue?vue&type=template&id=a503a40c&"
import script from "./RentalSpace.vue?vue&type=script&lang=js&"
export * from "./RentalSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports